import { useShallow } from "zustand/shallow";
import { t } from "i18next";
import { StepNavigator } from "mobily-ui-library"
import { useGlobalStore } from "../stores/globalStore";
import { useCheckoutStore } from "../stores/checkoutStore";
import { getProductTitle } from "../utils";

const PROGRESS_MAP: Record<string, number | null> = {
    "FTTH-Lead": 50,
    "MeshExtender": 50,
    "RequestDetails": 50,
    "OTPVerification": 80,
    "OrderSummary": 80,
};

export const StepsMenu = () => {
    const { lang, graphqlResponse } = useGlobalStore(
        useShallow((state) => ({
            lang: state.lang,
            graphqlResponse: state.graphqlResponse
        }))
    );

    const { currentSection, goToPreviousStep } = useCheckoutStore(
        useShallow((state) => ({
            currentSection: state.currentSection,
            goToPreviousStep: state.goToPreviousStep,
        }))
    );

    const handleNavigateBack = () => {
        goToPreviousStep();
    }
    const rtl = lang === 'ar' ? true : false;

    const progress = PROGRESS_MAP[currentSection?.sectionId || ""] ?? 50;
    const helpUrl = (window as any)["contact_us_url"];


    const productTitle = getProductTitle(graphqlResponse, lang ?? 'en');

    return (
        <StepNavigator
            title={productTitle}
            progress={progress}
            onBack={handleNavigateBack}
            helpButton={t("help")}
            link={helpUrl}
            rtl={rtl}
        />
    )
}